import tw from 'tailwind-styled-components'
import {MoveToBody} from '@components/move-to-body'
import {Padding} from '../design-system/types'
import {TwDividerType, TwWndType} from './types'

export const TwMoveToBody = tw(MoveToBody)`
  top-0
`

const getPaddings = (paddings?: Padding) => {
  if (paddings === 0) {
    return '!p-0'
  }
  if (paddings === undefined) {
    return ''
  }
  if (paddings === 16) {
    return 'p-16'
  }
  return 'p-24 pb-20'
}

export const TwWnd = tw.div<TwWndType>`
  relative
  bg-background-primary
  overflow-hidden
  flex
  flex-col
  shadow-xl
  max-h-[calc(100%-48px)]
  ${p => {
    if (p.$autoHeight) {
      return 'h-auto'
    }

    if (p.$height) {
      return '' // by inline-style
    }

    return 'h-[calc(100%-96px)]'
  }}
  ${p => (p.$minHeightAuto ? 'min-h-[auto]' : 'min-h-[300px]')}
  ${p => (p.$rounded === '8' ? 'rounded-8' : 'rounded-16')}
`

export const TwCnt = tw.div<{$paddings?: Padding}>`
  text-sm-regular
  flex-auto
  px-24
  py-8
  min-w-0
  ${p => getPaddings(p.$paddings)}
`

export const TwFooter = tw.div<{$paddings?: Padding}>`
  text-center
  p-16
  z-1000

  text-sm-regular
  ${p => getPaddings(p.$paddings)}
`

export const closeClassName =
  'cursor-pointer flex-shrink-0 fill-grey text-grey-l60'

export const TwHeader = tw.div<{
  $paddings?: Padding
  $type: 'popup' | 'dialog'
  $autoHeightHeader?: boolean
}>`
  bg-background-primary
  flex
  flex-shrink-0
  cursor-default
  text-left

  ${p => getPaddings(p.$paddings)}

  ${p => {
    if (p.$type === 'dialog') {
      return 'min-h-56 pt-24 pb-4'
    }

    if (p.$autoHeightHeader) {
      return 'h-auto pt-24 pb-12'
    }

    return ''
  }}
`

export const TwHeaderTitleWrapper = tw.div`
  flex
  flex-col
  flex-grow
  gap-8
`

export const TwHeaderTitle = tw.div`
  h1-semibold
  text-primary
`

export const TwHeaderSubtitleTitle = tw.div`
  text-secondary
  leading-4
  text-14
`

export const TwDivider = tw.div<TwDividerType>`
  h-1
  max-h-1
  min-h-1
  bg-grey-l60

  ${p => (p.$style === 'visible' ? '' : 'mx-24')}
`
